import { render, staticRenderFns } from "./YellowBox.vue?vue&type=template&id=c2b2c9d2&"
import script from "./YellowBox.vue?vue&type=script&lang=js&"
export * from "./YellowBox.vue?vue&type=script&lang=js&"
import style0 from "./YellowBox.vue?vue&type=style&index=0&id=c2b2c9d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports